import { render } from "./NavbarLinks.vue?vue&type=template&id=66e10a4e"
import script from "./NavbarLinks.vue?vue&type=script&lang=js"
export * from "./NavbarLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__